import { Fragment, useState, useEffect } from "react";
import { Profile } from "../../types";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import PhoneInput from "react-phone-number-input";
import ShowToast from "../../components/alerts/all_toasts";
import { Input } from "antd";
import { fetchMyProfile, updateMyProfile } from "../../helpers/profile";
import { saveSessionUser } from "../../helpers/authSession";

const EditPersonal = ({
  handleStepChange,
}: {
  handleStepChange: () => void;
}) => {
  const [userPersonal, setPersonalData] = useState<Profile | null>();
  const [isLoading, setIsLoading] = useState(false);
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [email, setEmail] = useState("");

  // logic to get user profile information
  const getUserData = async () => {
    setIsLoading(true);
    try {
      setPersonalData(await fetchMyProfile());
    } catch {
      ShowToast.error_toast("Couldn't load your profile. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // logic to submit edited profile values — only send what changed
  const handleSubmit = async () => {
    const changes: { first_name?: string; last_name?: string; email?: string } =
      {};
    if (first_name.trim() && first_name.trim() !== userPersonal?.first_name) {
      changes.first_name = first_name.trim();
    }
    if (last_name.trim() && last_name.trim() !== userPersonal?.last_name) {
      changes.last_name = last_name.trim();
    }
    if (email.trim() && email.trim() !== userPersonal?.email) {
      changes.email = email.trim();
    }
    if (!Object.keys(changes).length) {
      handleStepChange();
      return;
    }

    setIsLoading(true);
    try {
      const updated = await updateMyProfile(changes);
      // Payment flows read the name from the stored session.
      saveSessionUser(updated);
      ShowToast.success_toast("Profile has been updated!");
      handleStepChange();
      window.location.reload();
    } catch (e: any) {
      ShowToast.error_toast(e?.response?.data?.message || e?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getUserData();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <div className="h-screen overflow-hidden bg-neutral-50 dark:bg-dark-100">
        <div className="h-full mt-5">
          <div className="flex justify-between items-center mx-[20px]">
            <div className="flex-[0.3]">
              <button
                className="h-10 text-neutral-300 flex justify-center items-center"
                onClick={() => handleStepChange()}
              >
                <ChevronLeftIcon className="h-6 w-6 font-bold" />
              </button>
            </div>
            <div className="flex-[0.7]">
              <h4 className="text-header-4">Personal</h4>
            </div>
          </div>

          {isLoading ? (
            <div className="mt-5">
              <div className="mt-5 border-b border-neutral-100 animate-pulse">
                <div className="flex gap-3 items-center pb-3 mx-[20px]">
                  <div className="w-[20px] h-[20px] bg-gray-300" />
                  <div className="bg-gray-300 w-[80%] h-[20px]" />
                </div>
              </div>
              <div className="mt-5 border-b border-neutral-100 animate-pulse">
                <div className="flex gap-3 items-center pb-3 mx-[20px]">
                  <div className="w-[20px] h-[20px] bg-gray-300" />
                  <div className="bg-gray-300 w-[80%] h-[20px]" />
                </div>
              </div>
            </div>
          ) : (
            <div className="mt-5 h-screen overflow-y-auto">
              <div className="border-neutral-100 border-b pb-5">
                <div className="mx-[20px]">
                  <div className="mt-5">
                    <div className="text-header-4">Name</div>
                    <div>
                      <div className="text-caption py-2 ml-1">First name</div>
                      <input
                        onChange={(e) => setFirstName(e.target.value)}
                        defaultValue={userPersonal?.first_name ?? ""}
                        className="input-container w-full text-2xl"
                      />
                    </div>
                    <div>
                      <div className="text-caption py-2 ml-1">Last name</div>
                      <input
                        onChange={(e) => setLastName(e.target.value)}
                        defaultValue={userPersonal?.last_name ?? ""}
                        className="input-container w-full text-2xl"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className=" border-neutral-100 mt-5 border-b pb-5">
                <div className="mx-[20px]">
                  <div className="mt-5">
                    <div className="text-header-4">Email address</div>
                    <div>
                      <div className="text-caption py-2 ml-1">
                        Email address
                      </div>
                      <Input
                        className=" h-[50px] rounded-lg border border-[#939291] text-2xl"
                        suffix={<img src="/sms.png" alt="mail" />}
                        onChange={(e) => setEmail(e.target.value)}
                        defaultValue={userPersonal?.email ?? ""}
                        type="email"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-5 pb-5">
                <div className="mx-[20px]">
                  <div className="mt-5">
                    <div className="text-header-4">Number</div>
                    <div>
                      <div className="text-caption py-2 ml-1">
                        Mobile number
                      </div>
                      <div>
                        <PhoneInput
                          className="input-container  text-2xl"
                          defaultCountry="GH"
                          inputStyle={{ width: "100%" }}
                          value={userPersonal?.phone}
                          onChange={() => {}}
                          disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-evenly items-center mt-8">
                <button
                  className="text-neutral-300 font-medium"
                  onClick={() => handleStepChange()}
                >
                  Cancel
                </button>
                <button
                  className="font-semibold text-primary"
                  onClick={() => handleSubmit()}
                >
                  Save
                </button>
              </div>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default EditPersonal;
